import React from 'react';
import {VideoEditorText} from '../VideoEditorText';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
// import {ReactComponent as EditScriptIcon} from '../../../assets/images/sound-file-icon.svg';
// import {ReactComponent as MuteAudioIcon} from '../../../assets/images/mute-icon.svg';
import {ReactComponent as RegenerateIcon} from '../../../assets/images/regenerate-icon.svg';
import {ReactComponent as ChangeMediaIcon} from '../../../assets/images/changeMedia.svg';
import {ReactComponent as DeleteIcon} from '../../../assets/images/trash-icon.svg';
import {ReactComponent as EditIcon} from '../../../assets/images/edit.svg';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import styles from './EditChunkOptions.module.css';
import {ReactComponent as Dots} from '../../../assets/images/dots-horizontal.svg';
import ContextMenuProviderStore from '../../../modules/ContextMenuProvider/store/ContextMenuProviderStore';
import {inject} from 'mobx-react';
import {appText} from '../../../assets/text/appText';
import ConfirmationModal from '../../../uiToolkit/ConfirmationModal';

interface Props {
  chunk: GeneratedVideoChunk;
  onEditChunk: (option: EditChunkOption, chunkId: string) => void;
  contextMenuProviderStore?: ContextMenuProviderStore;
  isTiny: boolean;
  // Microreel scope editing: deleting a scene would change the reel's
  // footprint in the video, so the option is not offered at all.
  hideDelete?: boolean;
}

const EditChunkOptions = inject('contextMenuProviderStore')(
  React.memo(
    ({
      chunk,
      onEditChunk,
      contextMenuProviderStore,
      isTiny,
      hideDelete = false,
    }: Props) => {
      const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);
      const isNonAiOrigin = chunk.origin !== 1;

      // const onEditScriptOption = () => {
      //   contextMenuProviderStore?.close();
      //   onEditChunk(EditChunkOption.EditScript, chunk.id);
      //   contextMenuProviderStore?.close();
      // };
      // const onMuteAudioOption = () => {
      //   contextMenuProviderStore?.close();
      //   onEditChunk(EditChunkOption.MuteAudio, chunk.id);
      //   contextMenuProviderStore?.close();
      // };
      const onRegenerateOption = () => {
        contextMenuProviderStore?.close();
        onEditChunk(EditChunkOption.Regenerate, chunk.id);
        contextMenuProviderStore?.close();
      };

      const onEditMediaOption = () => {
        onEditChunk(EditChunkOption.EditMedia, chunk.id);
        contextMenuProviderStore?.close();
      };
      const onDeleteOption = () => {
        onEditChunk(EditChunkOption.Delete, chunk.id);
        contextMenuProviderStore?.close();
      };

      const onEditNarrationOption = () => {
        onEditChunk(EditChunkOption.EditNarration, chunk.id);
        contextMenuProviderStore?.close();
      };

      const EditOption = ({
        onClick,
        icon: Icon,
        label,
        disabled = false,
        extraClass = '',
        tooltip,
      }: {
        onClick: () => void;
        icon: React.ElementType;
        label: string;
        disabled?: boolean;
        extraClass?: string;
        tooltip?: string;
      }) => {
        return (
          <div
            className={`${styles.option} ${extraClass} ${
              disabled ? styles.disabled : ''
            }`}
            onClick={!disabled ? onClick : undefined}
            role="button"
            aria-disabled={disabled}
            title={disabled && tooltip ? tooltip : undefined}>
            <Icon className={styles.editVideoOptionIcon} />
            {label}
          </div>
        );
      };

      const openOptions = (e: React.MouseEvent) => {
        contextMenuProviderStore?.show(
          <div className={styles.options}>
            {/* <EditOption
              onClick={onEditScriptOption}
              icon={EditScriptIcon}
              label={VideoEditorText.editVideoOptions_EditScript}
            /> */}
            {/* <EditOption
              onClick={onMuteAudioOption}
              icon={MuteAudioIcon}
              label={VideoEditorText.editVideoOptions_MuteAudio}
              disabled={!chunk.audioUri}
            /> */}
            <EditOption
              onClick={onRegenerateOption}
              icon={RegenerateIcon}
              label={VideoEditorText.editVideoOptions_Regenerate}
              disabled={isNonAiOrigin || chunk.notSupportedToRegenerate}
              tooltip={
                isNonAiOrigin
                  ? VideoEditorText.editVideoOptions_Disabled
                  : undefined
              }
            />
            <EditOption
              onClick={onEditMediaOption}
              icon={ChangeMediaIcon}
              label={VideoEditorText.editVideoOptions_EditMedia}
              disabled={isNonAiOrigin}
              tooltip={
                isNonAiOrigin
                  ? VideoEditorText.editVideoOptions_Disabled
                  : undefined
              }
            />
            <EditOption
              onClick={onEditNarrationOption}
              icon={EditIcon}
              label={VideoEditorText.editVideoOptions_EditNarration}
            />
            {!hideDelete && (
              <EditOption
                onClick={showModal}
                icon={DeleteIcon}
                label={VideoEditorText.editVideoOptions_Delete}
                extraClass={styles.deleteOption}
              />
            )}
          </div>,
          {x: e.clientX, y: e.clientY},
        );
      };

      const showModal = () => {
        setShowConfirmDelete(true);
        contextMenuProviderStore?.close();
      };
      const cancelModal = () => {
        setShowConfirmDelete(false);
        contextMenuProviderStore?.close();
      };

      return (
        <div
          className={`${styles.editChunkOptions} ${
            isTiny ? styles.tinyChunk : ''
          }`}>
          <button className={styles.opener} onClick={openOptions}>
            <Dots />
          </button>

          <ConfirmationModal
            title={VideoEditorText.editVideoOptions_ConfirmDelete}
            onAccept={onDeleteOption}
            onCancel={cancelModal}
            shown={showConfirmDelete}
            acceptText={appText.delete}
          />
        </div>
      );
    },
  ),
);

export default EditChunkOptions;
